import { useHistory } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { supabase } from "../../supabase";
import useAuth from "../../hooks/useAuth";
import { useTranslation } from "react-i18next";
import "./Gallery.css";

/* 갤러리 카드 (2026-10-16 리뉴얼: 정사각 접시 썸네일 · 인기 배지 · 비회원 하트 안내) */
export default function GalleryCard({ post, popular = false }) {
  const history = useHistory();
  const { t } = useTranslation();
  const { user } = useAuth();
  const [liked, setLiked] = useState(false);
  const [likeAnimating, setLikeAnimating] = useState(false);
  const [likeCount, setLikeCount] = useState(post?.like_count || 0);
  const [guestToast, setGuestToast] = useState(false);
  const toastTimerRef = useRef(null);

  useEffect(() => {
    if (!user?.id || !post?.id) return;
    supabase
      .from("gallery_likes")
      .select("id")
      .eq("user_id", user.id)
      .eq("gallery_id", post.id)
      .maybeSingle()
      .then(({ data }) => setLiked(!!data));
  }, [user?.id, post?.id]);

  useEffect(() => () => clearTimeout(toastTimerRef.current), []);

  if (!post) return null;

  const thumb = post.thumbnail_url || "/placeholder-thumb.png";

  async function handleLike(e) {
    e.stopPropagation();
    if (!user?.id) {
      // 비회원: 좋아요는 누르지 않고 하트 밑에 안내 말풍선
      setGuestToast(true);
      clearTimeout(toastTimerRef.current);
      toastTimerRef.current = setTimeout(() => setGuestToast(false), 2500);
      return;
    }
    if (likeAnimating) return;

    setLikeAnimating(true);
    setTimeout(() => setLikeAnimating(false), 400);

    if (liked) {
      setLiked(false);
      setLikeCount((c) => Math.max(0, c - 1));
      await supabase
        .from("gallery_likes")
        .delete()
        .eq("user_id", user.id)
        .eq("gallery_id", post.id);
    } else {
      setLiked(true);
      setLikeCount((c) => c + 1);
      await supabase
        .from("gallery_likes")
        .insert({ user_id: user.id, gallery_id: post.id });
    }
  }

  return (
    <div
      className="gl-card"
      onClick={() => history.push(`/gallery/${post.id}`)}
    >
      <div className="gl-thumb">
        <img src={thumb} alt={post.title || ""} loading="lazy" />
        {popular && <span className="gl-badge">{t("galleryUi.popular")}</span>}
        <span className="gl-hover"><b>{t("galleryUi.viewDetail")}</b></span>
      </div>

      <button
        type="button"
        className={`gl-heart ${liked ? "liked" : ""} ${likeAnimating ? "pop" : ""}`}
        onClick={handleLike}
        aria-label={t("galleryUi.like")}
      >
        {liked ? "♥" : "♡"}
      </button>
      {guestToast && (
        <div className="gl-toast" onClick={(e) => e.stopPropagation()}>
          {t("galleryUi.likeLoginToast")}
          <button type="button" onClick={() => history.push("/login")}>
            {t("galleryUi.login")}
          </button>
        </div>
      )}

      <div className="gl-cb">
        <b className="gl-ct">{post.title}</b>
        <div className="gl-mt">
          <span className="gl-au">
            {post.profiles?.username || post.username || post.user_id}
          </span>
          <span className="gl-st">
            <i>↓</i>{post.download_count || 0}
            <i className="h">♥</i>{likeCount}
          </span>
        </div>
      </div>
    </div>
  );
}
